/**
 * Generated by orval v8.4.2 🍺
 * Do not edit manually.
 * The SKY API
 * OpenAPI spec version: 1.0.0
 */
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";
import { useMutation, useQuery } from "@tanstack/react-query";

import type {
  BadRequestResponse,
  CompleteReportSampleUpload200,
  CompleteReportSampleUploadBody,
  CreateCustomReportBody,
  CreateTemplateInput,
  ForbiddenResponse,
  GetReportSamplePartUrl200,
  GetReportSamplePartUrlBody,
  InternalServerErrorResponse,
  NotFoundResponse,
  RegenerateReportSectionInput,
  Report,
  ReportList,
  ReportSection,
  StartReportSampleUpload200,
  StartReportSampleUploadBody,
  Template,
  TemplateList,
  UnauthorizedResponse,
  UpdateReportSectionInput,
  UpdateTemplateInput,
} from ".././model";

import { customInstance } from "../../custom-instance";

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

/**
 * Retrieves a list of custom report templates for the specified organization from the external SKY Custom Report API
 * @summary Get list of custom report templates
 */
export const getTemplateList = (
  organizationId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<TemplateList>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetTemplateListQueryKey = (organizationId: string) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates`,
  ] as const;
};

export const getGetTemplateListQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ?? getGetTemplateListQueryKey(organizationId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplateList>>> = ({
    signal,
  }) => getTemplateList(organizationId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!organizationId,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplateList>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateListQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplateList>>
>;
export type GetTemplateListQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateList>>,
          TError,
          Awaited<ReturnType<typeof getTemplateList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplateList>>,
          TError,
          Awaited<ReturnType<typeof getTemplateList>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get list of custom report templates
 */

export function useGetTemplateList<
  TData = Awaited<ReturnType<typeof getTemplateList>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getTemplateList>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateListQueryOptions(organizationId, options);

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Creates a custom report template via the external SKY Custom Report API
 * @summary Create a custom report template
 */
export const createTemplate = (
  organizationId: string,
  createTemplateInput: CreateTemplateInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Template>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createTemplateInput,
      signal,
    },
    options
  );
};

export const getCreateTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createTemplate>>,
    TError,
    { organizationId: string; data: CreateTemplateInput },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { organizationId: string; data: CreateTemplateInput },
  TContext
> => {
  const mutationKey = ["createTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createTemplate>>,
    { organizationId: string; data: CreateTemplateInput }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createTemplate(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof createTemplate>>
>;
export type CreateTemplateMutationBody = CreateTemplateInput;
export type CreateTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a custom report template
 */
export const useCreateTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createTemplate>>,
      TError,
      { organizationId: string; data: CreateTemplateInput },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createTemplate>>,
  TError,
  { organizationId: string; data: CreateTemplateInput },
  TContext
> => {
  return useMutation(getCreateTemplateMutationOptions(options), queryClient);
};
/**
 * Retrieves a custom report template by ID from the external SKY Custom Report API
 * @summary Get a custom report template by ID
 */
export const getTemplate = (
  organizationId: string,
  templateId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Template>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/${templateId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetTemplateQueryKey = (
  organizationId: string,
  templateId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/${templateId}`,
  ] as const;
};

export const getGetTemplateQueryOptions = <
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetTemplateQueryKey(organizationId, templateId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getTemplate>>> = ({
    signal,
  }) => getTemplate(organizationId, templateId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && templateId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getTemplate>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetTemplateQueryResult = NonNullable<
  Awaited<ReturnType<typeof getTemplate>>
>;
export type GetTemplateQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options: {
    query: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getTemplate>>,
          TError,
          Awaited<ReturnType<typeof getTemplate>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report template by ID
 */

export function useGetTemplate<
  TData = Awaited<ReturnType<typeof getTemplate>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  templateId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<Awaited<ReturnType<typeof getTemplate>>, TError, TData>
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetTemplateQueryOptions(
    organizationId,
    templateId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates a custom report template by ID via the external SKY Custom Report API
 * @summary Update a custom report template by ID
 */
export const updateTemplate = (
  organizationId: string,
  templateId: string,
  updateTemplateInput: UpdateTemplateInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Template>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/${templateId}`,
      method: "PUT",
      headers: { "Content-Type": "application/json" },
      data: updateTemplateInput,
      signal,
    },
    options
  );
};

export const getUpdateTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateTemplate>>,
    TError,
    { organizationId: string; templateId: string; data: UpdateTemplateInput },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { organizationId: string; templateId: string; data: UpdateTemplateInput },
  TContext
> => {
  const mutationKey = ["updateTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateTemplate>>,
    { organizationId: string; templateId: string; data: UpdateTemplateInput }
  > = (props) => {
    const { organizationId, templateId, data } = props ?? {};

    return updateTemplate(organizationId, templateId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateTemplate>>
>;
export type UpdateTemplateMutationBody = UpdateTemplateInput;
export type UpdateTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update a custom report template by ID
 */
export const useUpdateTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateTemplate>>,
      TError,
      { organizationId: string; templateId: string; data: UpdateTemplateInput },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateTemplate>>,
  TError,
  { organizationId: string; templateId: string; data: UpdateTemplateInput },
  TContext
> => {
  return useMutation(getUpdateTemplateMutationOptions(options), queryClient);
};
/**
 * Deletes a custom report template by ID via the external SKY Custom Report API
 * @summary Delete a custom report template by ID
 */
export const deleteTemplate = (
  organizationId: string,
  templateId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/${templateId}`,
      method: "DELETE",
      signal,
    },
    options
  );
};

export const getDeleteTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof deleteTemplate>>,
    TError,
    { organizationId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  const mutationKey = ["deleteTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof deleteTemplate>>,
    { organizationId: string; templateId: string }
  > = (props) => {
    const { organizationId, templateId } = props ?? {};

    return deleteTemplate(organizationId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type DeleteTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof deleteTemplate>>
>;

export type DeleteTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Delete a custom report template by ID
 */
export const useDeleteTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof deleteTemplate>>,
      TError,
      { organizationId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof deleteTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  return useMutation(getDeleteTemplateMutationOptions(options), queryClient);
};
/**
 * Set a template as the default for its organization. Other templates will be unset as default.
 * @summary Set template as default
 */
export const setDefaultTemplate = (
  organizationId: string,
  templateId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<void>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/${templateId}/default`,
      method: "POST",
      signal,
    },
    options
  );
};

export const getSetDefaultTemplateMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof setDefaultTemplate>>,
    TError,
    { organizationId: string; templateId: string },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof setDefaultTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  const mutationKey = ["setDefaultTemplate"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof setDefaultTemplate>>,
    { organizationId: string; templateId: string }
  > = (props) => {
    const { organizationId, templateId } = props ?? {};

    return setDefaultTemplate(organizationId, templateId, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type SetDefaultTemplateMutationResult = NonNullable<
  Awaited<ReturnType<typeof setDefaultTemplate>>
>;

export type SetDefaultTemplateMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Set template as default
 */
export const useSetDefaultTemplate = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof setDefaultTemplate>>,
      TError,
      { organizationId: string; templateId: string },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof setDefaultTemplate>>,
  TError,
  { organizationId: string; templateId: string },
  TContext
> => {
  return useMutation(
    getSetDefaultTemplateMutationOptions(options),
    queryClient
  );
};
/**
 * Creates a custom report for a case using the provided template. Accepts idempotencyKey, caseId and templateId to generate the report asynchronously.

 * @summary Create a custom report for a case
 */
export const createCustomReport = (
  organizationId: string,
  createCustomReportBody: CreateCustomReportBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Report>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reports`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: createCustomReportBody,
      signal,
    },
    options
  );
};

export const getCreateCustomReportMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof createCustomReport>>,
    TError,
    { organizationId: string; data: CreateCustomReportBody },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof createCustomReport>>,
  TError,
  { organizationId: string; data: CreateCustomReportBody },
  TContext
> => {
  const mutationKey = ["createCustomReport"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof createCustomReport>>,
    { organizationId: string; data: CreateCustomReportBody }
  > = (props) => {
    const { organizationId, data } = props ?? {};

    return createCustomReport(organizationId, data, requestOptions);
  };

  return { mutationFn, ...mutationOptions };
};

export type CreateCustomReportMutationResult = NonNullable<
  Awaited<ReturnType<typeof createCustomReport>>
>;
export type CreateCustomReportMutationBody = CreateCustomReportBody;
export type CreateCustomReportMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Create a custom report for a case
 */
export const useCreateCustomReport = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof createCustomReport>>,
      TError,
      { organizationId: string; data: CreateCustomReportBody },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof createCustomReport>>,
  TError,
  { organizationId: string; data: CreateCustomReportBody },
  TContext
> => {
  return useMutation(
    getCreateCustomReportMutationOptions(options),
    queryClient
  );
};
/**
 * Retrieves a custom report by ID including all report sections and their content
 * @summary Get a custom report by ID
 */
export const getCustomReport = (
  organizationId: string,
  reportId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<Report>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reports/${reportId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetCustomReportQueryKey = (
  organizationId: string,
  reportId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reports/${reportId}`,
  ] as const;
};

export const getGetCustomReportQueryOptions = <
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetCustomReportQueryKey(organizationId, reportId);

  const queryFn: QueryFunction<Awaited<ReturnType<typeof getCustomReport>>> = ({
    signal,
  }) => getCustomReport(organizationId, reportId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && reportId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getCustomReport>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetCustomReportQueryResult = NonNullable<
  Awaited<ReturnType<typeof getCustomReport>>
>;
export type GetCustomReportQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getCustomReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getCustomReport>>,
          TError,
          Awaited<ReturnType<typeof getCustomReport>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report by ID
 */

export function useGetCustomReport<
  TData = Awaited<ReturnType<typeof getCustomReport>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getCustomReport>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetCustomReportQueryOptions(
    organizationId,
    reportId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Retrieves list of custom reports for a case with calculated statuses based on snapshot information
 * @summary List custom reports by case ID
 */
export const listCustomReportsByCase = (
  organizationId: string,
  caseId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportList>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reports/case/${caseId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getListCustomReportsByCaseQueryKey = (
  organizationId: string,
  caseId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reports/case/${caseId}`,
  ] as const;
};

export const getListCustomReportsByCaseQueryOptions = <
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListCustomReportsByCaseQueryKey(organizationId, caseId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listCustomReportsByCase>>
  > = ({ signal }) =>
    listCustomReportsByCase(organizationId, caseId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && caseId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listCustomReportsByCase>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListCustomReportsByCaseQueryResult = NonNullable<
  Awaited<ReturnType<typeof listCustomReportsByCase>>
>;
export type ListCustomReportsByCaseQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  caseId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomReportsByCase>>,
          TError,
          Awaited<ReturnType<typeof listCustomReportsByCase>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listCustomReportsByCase>>,
          TError,
          Awaited<ReturnType<typeof listCustomReportsByCase>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List custom reports by case ID
 */

export function useListCustomReportsByCase<
  TData = Awaited<ReturnType<typeof listCustomReportsByCase>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  caseId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listCustomReportsByCase>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListCustomReportsByCaseQueryOptions(
    organizationId,
    caseId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Retrieves a custom report section by ID from the external SKY Custom Report API
 * @summary Get a custom report section by ID
 */
export const getReportSection = (
  organizationId: string,
  reportSectionId: string,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportSection>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reportSections/${reportSectionId}`,
      method: "GET",
      signal,
    },
    options
  );
};

export const getGetReportSectionQueryKey = (
  organizationId: string,
  reportSectionId: string
) => {
  return [
    `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reportSections/${reportSectionId}`,
  ] as const;
};

export const getGetReportSectionQueryOptions = <
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  }
) => {
  const { query: queryOptions, request: requestOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getGetReportSectionQueryKey(organizationId, reportSectionId);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof getReportSection>>
  > = ({ signal }) =>
    getReportSection(organizationId, reportSectionId, requestOptions, signal);

  return {
    queryKey,
    queryFn,
    enabled: !!(organizationId && reportSectionId),
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof getReportSection>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type GetReportSectionQueryResult = NonNullable<
  Awaited<ReturnType<typeof getReportSection>>
>;
export type GetReportSectionQueryError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportSectionId: string,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportSection>>,
          TError,
          Awaited<ReturnType<typeof getReportSection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getReportSection>>,
          TError,
          Awaited<ReturnType<typeof getReportSection>>
        >,
        "initialData"
      >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary Get a custom report section by ID
 */

export function useGetReportSection<
  TData = Awaited<ReturnType<typeof getReportSection>>,
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
>(
  organizationId: string,
  reportSectionId: string,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof getReportSection>>,
        TError,
        TData
      >
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getGetReportSectionQueryOptions(
    organizationId,
    reportSectionId,
    options
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * Updates the content of a custom report section manually
 * @summary Update a custom report section content
 */
export const updateReportSection = (
  organizationId: string,
  reportSectionId: string,
  updateReportSectionInput: UpdateReportSectionInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportSection>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reportSections/${reportSectionId}`,
      method: "PATCH",
      headers: { "Content-Type": "application/json" },
      data: updateReportSectionInput,
      signal,
    },
    options
  );
};

export const getUpdateReportSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof updateReportSection>>,
    TError,
    {
      organizationId: string;
      reportSectionId: string;
      data: UpdateReportSectionInput;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof updateReportSection>>,
  TError,
  {
    organizationId: string;
    reportSectionId: string;
    data: UpdateReportSectionInput;
  },
  TContext
> => {
  const mutationKey = ["updateReportSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof updateReportSection>>,
    {
      organizationId: string;
      reportSectionId: string;
      data: UpdateReportSectionInput;
    }
  > = (props) => {
    const { organizationId, reportSectionId, data } = props ?? {};

    return updateReportSection(
      organizationId,
      reportSectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type UpdateReportSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof updateReportSection>>
>;
export type UpdateReportSectionMutationBody = UpdateReportSectionInput;
export type UpdateReportSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Update a custom report section content
 */
export const useUpdateReportSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof updateReportSection>>,
      TError,
      {
        organizationId: string;
        reportSectionId: string;
        data: UpdateReportSectionInput;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof updateReportSection>>,
  TError,
  {
    organizationId: string;
    reportSectionId: string;
    data: UpdateReportSectionInput;
  },
  TContext
> => {
  return useMutation(
    getUpdateReportSectionMutationOptions(options),
    queryClient
  );
};
/**
 * Regenerates a specific section of a custom report asynchronously. Requires caseId and idempotencyKey to ensure idempotent operations.
 * @summary Regenerate a custom report section
 */
export const regenerateSection = (
  organizationId: string,
  reportSectionId: string,
  regenerateReportSectionInput: RegenerateReportSectionInput,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<ReportSection>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/reportSections/${reportSectionId}/regenerate`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: regenerateReportSectionInput,
      signal,
    },
    options
  );
};

export const getRegenerateSectionMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof regenerateSection>>,
    TError,
    {
      organizationId: string;
      reportSectionId: string;
      data: RegenerateReportSectionInput;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof regenerateSection>>,
  TError,
  {
    organizationId: string;
    reportSectionId: string;
    data: RegenerateReportSectionInput;
  },
  TContext
> => {
  const mutationKey = ["regenerateSection"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof regenerateSection>>,
    {
      organizationId: string;
      reportSectionId: string;
      data: RegenerateReportSectionInput;
    }
  > = (props) => {
    const { organizationId, reportSectionId, data } = props ?? {};

    return regenerateSection(
      organizationId,
      reportSectionId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type RegenerateSectionMutationResult = NonNullable<
  Awaited<ReturnType<typeof regenerateSection>>
>;
export type RegenerateSectionMutationBody = RegenerateReportSectionInput;
export type RegenerateSectionMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Regenerate a custom report section
 */
export const useRegenerateSection = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof regenerateSection>>,
      TError,
      {
        organizationId: string;
        reportSectionId: string;
        data: RegenerateReportSectionInput;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof regenerateSection>>,
  TError,
  {
    organizationId: string;
    reportSectionId: string;
    data: RegenerateReportSectionInput;
  },
  TContext
> => {
  return useMutation(getRegenerateSectionMutationOptions(options), queryClient);
};
/**
 * Starts a multipart upload for a report sample file that will be used to generate a template
 * @summary Initiate S3 multipart upload for report sample
 */
export const startReportSampleUpload = (
  organizationId: string,
  uploadId: string,
  startReportSampleUploadBody: StartReportSampleUploadBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<StartReportSampleUpload200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/upload/${uploadId}/start`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: startReportSampleUploadBody,
      signal,
    },
    options
  );
};

export const getStartReportSampleUploadMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof startReportSampleUpload>>,
    TError,
    {
      organizationId: string;
      uploadId: string;
      data: StartReportSampleUploadBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof startReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: StartReportSampleUploadBody;
  },
  TContext
> => {
  const mutationKey = ["startReportSampleUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof startReportSampleUpload>>,
    {
      organizationId: string;
      uploadId: string;
      data: StartReportSampleUploadBody;
    }
  > = (props) => {
    const { organizationId, uploadId, data } = props ?? {};

    return startReportSampleUpload(
      organizationId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type StartReportSampleUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof startReportSampleUpload>>
>;
export type StartReportSampleUploadMutationBody = StartReportSampleUploadBody;
export type StartReportSampleUploadMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Initiate S3 multipart upload for report sample
 */
export const useStartReportSampleUpload = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof startReportSampleUpload>>,
      TError,
      {
        organizationId: string;
        uploadId: string;
        data: StartReportSampleUploadBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof startReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: StartReportSampleUploadBody;
  },
  TContext
> => {
  return useMutation(
    getStartReportSampleUploadMutationOptions(options),
    queryClient
  );
};
/**
 * Generates a presigned URL for uploading a specific part of the report sample multipart upload
 * @summary Get a presigned URL for a specific multipart part of report sample
 */
export const getReportSamplePartUrl = (
  organizationId: string,
  uploadId: string,
  getReportSamplePartUrlBody: GetReportSamplePartUrlBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<GetReportSamplePartUrl200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/upload/${uploadId}/part-url`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: getReportSamplePartUrlBody,
      signal,
    },
    options
  );
};

export const getGetReportSamplePartUrlMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof getReportSamplePartUrl>>,
    TError,
    {
      organizationId: string;
      uploadId: string;
      data: GetReportSamplePartUrlBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof getReportSamplePartUrl>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: GetReportSamplePartUrlBody;
  },
  TContext
> => {
  const mutationKey = ["getReportSamplePartUrl"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof getReportSamplePartUrl>>,
    {
      organizationId: string;
      uploadId: string;
      data: GetReportSamplePartUrlBody;
    }
  > = (props) => {
    const { organizationId, uploadId, data } = props ?? {};

    return getReportSamplePartUrl(
      organizationId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type GetReportSamplePartUrlMutationResult = NonNullable<
  Awaited<ReturnType<typeof getReportSamplePartUrl>>
>;
export type GetReportSamplePartUrlMutationBody = GetReportSamplePartUrlBody;
export type GetReportSamplePartUrlMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Get a presigned URL for a specific multipart part of report sample
 */
export const useGetReportSamplePartUrl = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof getReportSamplePartUrl>>,
      TError,
      {
        organizationId: string;
        uploadId: string;
        data: GetReportSamplePartUrlBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof getReportSamplePartUrl>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: GetReportSamplePartUrlBody;
  },
  TContext
> => {
  return useMutation(
    getGetReportSamplePartUrlMutationOptions(options),
    queryClient
  );
};
/**
 * Completes the multipart upload for a report sample and triggers template generation in the custom reports service
 * @summary Complete S3 multipart upload for report sample and generate template
 */
export const completeReportSampleUpload = (
  organizationId: string,
  uploadId: string,
  completeReportSampleUploadBody: CompleteReportSampleUploadBody,
  options?: SecondParameter<typeof customInstance>,
  signal?: AbortSignal
) => {
  return customInstance<CompleteReportSampleUpload200>(
    {
      url: `https://api.app.usesky.ai/organizations/${organizationId}/custom-reports/templates/upload/${uploadId}/complete`,
      method: "POST",
      headers: { "Content-Type": "application/json" },
      data: completeReportSampleUploadBody,
      signal,
    },
    options
  );
};

export const getCompleteReportSampleUploadMutationOptions = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof completeReportSampleUpload>>,
    TError,
    {
      organizationId: string;
      uploadId: string;
      data: CompleteReportSampleUploadBody;
    },
    TContext
  >;
  request?: SecondParameter<typeof customInstance>;
}): UseMutationOptions<
  Awaited<ReturnType<typeof completeReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: CompleteReportSampleUploadBody;
  },
  TContext
> => {
  const mutationKey = ["completeReportSampleUpload"];
  const { mutation: mutationOptions, request: requestOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey }, request: undefined };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof completeReportSampleUpload>>,
    {
      organizationId: string;
      uploadId: string;
      data: CompleteReportSampleUploadBody;
    }
  > = (props) => {
    const { organizationId, uploadId, data } = props ?? {};

    return completeReportSampleUpload(
      organizationId,
      uploadId,
      data,
      requestOptions
    );
  };

  return { mutationFn, ...mutationOptions };
};

export type CompleteReportSampleUploadMutationResult = NonNullable<
  Awaited<ReturnType<typeof completeReportSampleUpload>>
>;
export type CompleteReportSampleUploadMutationBody =
  CompleteReportSampleUploadBody;
export type CompleteReportSampleUploadMutationError =
  | BadRequestResponse
  | UnauthorizedResponse
  | ForbiddenResponse
  | NotFoundResponse
  | InternalServerErrorResponse;

/**
 * @summary Complete S3 multipart upload for report sample and generate template
 */
export const useCompleteReportSampleUpload = <
  TError =
    | BadRequestResponse
    | UnauthorizedResponse
    | ForbiddenResponse
    | NotFoundResponse
    | InternalServerErrorResponse,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof completeReportSampleUpload>>,
      TError,
      {
        organizationId: string;
        uploadId: string;
        data: CompleteReportSampleUploadBody;
      },
      TContext
    >;
    request?: SecondParameter<typeof customInstance>;
  },
  queryClient?: QueryClient
): UseMutationResult<
  Awaited<ReturnType<typeof completeReportSampleUpload>>,
  TError,
  {
    organizationId: string;
    uploadId: string;
    data: CompleteReportSampleUploadBody;
  },
  TContext
> => {
  return useMutation(
    getCompleteReportSampleUploadMutationOptions(options),
    queryClient
  );
};
